import { Asset, AssetType } from './Asset';
import { AssetObject } from './AssetObject';
import { EnemyConfig } from './EnemyGenerator';

export interface EnemyPrefabConfig {
  probability: number;
  minPoint: number;
  pathWidth: number;
  spawnRange: number;
  despawnRange: number;
  excludes?: string[];
}

export class EnemyPrefabs {
  static create(config: EnemyPrefabConfig): EnemyConfig {
    const scale = 2.2;
    const enemyConfig: EnemyConfig = {
      assets: [
        new Asset('enemy-male-a', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-a.glb').withMeshIndex(0),
        new Asset('enemy-male-b', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-b.glb').withMeshIndex(0),
        new Asset('enemy-male-c', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-c.glb').withMeshIndex(0),
        new Asset('enemy-male-d', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-d.glb').withMeshIndex(0),
        new Asset('enemy-male-e', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-e.glb').withMeshIndex(0),
        new Asset('enemy-male-f', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-f.glb').withMeshIndex(0),
        new Asset('enemy-female-a', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-a.glb').withMeshIndex(0),
        new Asset('enemy-female-b', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-b.glb').withMeshIndex(0),
        new Asset('enemy-female-c', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-c.glb').withMeshIndex(0),
        new Asset('enemy-female-d', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-d.glb').withMeshIndex(0),
        new Asset('enemy-female-e', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-e.glb').withMeshIndex(0),
        new Asset('enemy-female-f', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-f.glb').withMeshIndex(0),

        // new Asset('enemy-soldier', AssetType.MESH, 'assets/model/arena/', 'character-soldier.glb').withMeshIndex(0),
        // new Asset('enemy-human', AssetType.MESH, 'assets/model/dungeon/', 'character-human.glb').withMeshIndex(0),
        // new Asset('enemy-orc', AssetType.MESH, 'assets/model/dungeon/', 'character-orc.glb').withMeshIndex(0),
        // new Asset('enemy-ghost', AssetType.MESH, 'assets/model/graveyard/', 'character-ghost.glb').withMeshIndex(0),
        // new Asset('enemy-keeper', AssetType.MESH, 'assets/model/graveyard/', 'character-keeper.glb').withMeshIndex(0),
        // new Asset('enemy-skeleton', AssetType.MESH, 'assets/model/graveyard/', 'character-skeleton.glb').withMeshIndex(0),
        // new Asset('enemy-vampire', AssetType.MESH, 'assets/model/graveyard/', 'character-vampire.glb').withMeshIndex(0),
        // new Asset('enemy-zombie', AssetType.MESH, 'assets/model/graveyard/', 'character-zombie.glb').withMeshIndex(0),
      ].filter((a) => !config.excludes?.includes(a.name)),
      assetObjects: [
        AssetObject.fromAsset('enemy-male-a', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-male-b', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-male-c', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-male-d', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-male-e', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-male-f', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-female-a', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-female-b', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-female-c', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-female-d', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-female-e', scale).withType('enemy'),
        AssetObject.fromAsset('enemy-female-f', scale).withType('enemy'),

        // AssetObject.fromAsset('enemy-soldier', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-human', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-orc', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-ghost', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-keeper', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-skeleton', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-vampire', scale).withType('enemy'),
        // AssetObject.fromAsset('enemy-zombie', scale).withType('enemy'),
      ].filter((ao) => !config.excludes?.includes(ao.asset)),
      distributions: [
        {
          types: ['enemy'],
          behavior: 'mimic',
          probability: config.probability,
          detectionRange: 15,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'chargeJump',
          probability: config.probability,
          detectionRange: 25,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'teleport',
          probability: config.probability,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'snipe',
          probability: config.probability,
          offsetRange: { min: -4, max: 4 },
          speed: 10,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'patrol',
          probability: config.probability,
          offsetRange: { min: -1, max: 1 },
          patrolWidth: 6,
          speed: 2,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'circle',
          probability: config.probability,
          offsetRange: { min: -1, max: 1 },
          circleRadius: 2,
          speed: 3,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'attack',
          detectionRange: 12,
          attackRange: 2,
          offsetRange: { min: -4, max: 4 },
          probability: config.probability,
          speed: 4,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'idle',
          probability: config.probability,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },

        {
          types: ['enemy'],
          behavior: 'floatingBomber',
          floatHeight: 4,
          floatRadius: 3,
          bombInterval: 2.5,
          probability: config.probability,
          offsetRange: { min: -1, max: 1 },
          minPoint: config.minPoint,
        },
      ],
      spawnRange: config.spawnRange,
      despawnRange: config.despawnRange,
    };

    if (config.excludes && config.excludes.length > 0) {
      enemyConfig.distributions = enemyConfig.distributions.filter((distribution) => {
        const matchingAssets = enemyConfig.assetObjects.filter((ao) => distribution.types.includes(ao.type));
        return matchingAssets.length > 0;
      });
    }

    return enemyConfig;
  }
}
